import { render, staticRenderFns } from "./TibBannerTable.vue?vue&type=template&id=60ce4c8a"
import script from "./TibBannerTable.vue?vue&type=script&lang=js"
export * from "./TibBannerTable.vue?vue&type=script&lang=js"
import style0 from "./TibBannerTable.vue?vue&type=style&index=0&id=60ce4c8a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports